import { Button, useTheme } from '@mui/material';
import { AnnouncementActionTypes } from './types';

interface AnnouncementActionProps {
	action: AnnouncementActionTypes;
}

/**
 * Renders the Action for the Announcement
 */
export default function AnnouncementAction(props: AnnouncementActionProps) {
	const { palette } = useTheme();

	const handleClick = () => {
		switch (props.action) {
			// Until there is another Action Type the linter is saying this is silly
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
			case AnnouncementActionTypes.Update:
				window.location.reload();
				break;
			default:
				break;
		}
	};

	return (
		<Button
			variant='text'
			size='small'
			sx={{ color: palette.common.white }}
			onClick={handleClick}
		>
			{props.action}
		</Button>
	);
}
